import React from 'react';
import { createRoot } from 'react-dom/client'; // 更新导入
import { Provider } from 'react-redux';
import store from './store/index';
import Routes from './routes/index';
import './index'; // 引入 Sass 样式

// 使用 createRoot 渲染
const root = createRoot(document.getElementById('root')); // 创建根
root.render(
  <Provider store={store}>
    <Routes />
  </Provider>
);
